/**
 * This file contains the URLs that are linked to the assets in the /public folder for serving content.
 *
 * Use this file to dynamically control asset URLs that are publicly available.
 *
 * {
 *      @important DO NOT SERVE ANYTHING UNDER /src ONLINE
 * }
 */

export const urlLogo = process.env.PUBLIC_URL + '/logo.png';
export const urlLogo3x = process.env.PUBLIC_URL + '/logo@3x.png';
export const throbber = process.env.PUBLIC_URL + '/throbber/throbberRipple.svg';
export const throbber_fallback = process.env.PUBLIC_URL + '/throbber/throbberRipple.gif';
export const unread = process.env.PUBLIC_URL + '/unread/unreadRipple.svg';
export const unread_fallback = process.env.PUBLIC_URL + '/unread/unreadRipple.gif';
export const marker = process.env.PUBLIC_URL + '/autoi_mapicon.png';



// WEBPACK FOOTER //
// ./src/constants/asseturls.js